module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution7.991de75b.png";